import React, { useRef } from 'react';
import ReactMapboxGl from 'react-mapbox-gl';
import _get from 'lodash/get';

import MapLayer from './MapLayer';
import { isGraphicAccelerationEnabled } from 'utils/methods';

const MapElement = ReactMapboxGl({
  accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
});

// Source: https://www.mapbox.com/mapbox-gl-js/api/#lnglat
export default function Map(props) {
  const canRenderMap = useRef(isGraphicAccelerationEnabled()).current;

  const latitude = _get(props, 'address.latitude');
  const longitude = _get(props, 'address.longitude');

  if (!latitude || !longitude) {
    return null;
  }

  if (!canRenderMap) {
    console.warn(
      'Graphic acceleration is not enabled/supported. Disabled map rendering!'
    );
    return null;
  }

  return (
    <MapElement
      center={[longitude, latitude]}
      zoom={props.zoom ? [props.zoom] : [18]}
      containerStyle={{ height: '100%', width: '100%' }}
      // eslint-disable-next-line
      style="mapbox://styles/supplyaidev/cjofh96y1266u2st9u02dxr42"
    >
      <MapLayer {...props} />
    </MapElement>
  );
}
